export default "__VITE_ASSET__b09671e8__"